/**
 * navItems.ts — the portal panel roadmap as nav model.
 *
 * Health, Leads, Conversations, Config, and Numbers are all live. Numbers is
 * a single nav entry backed by two sub-routes: `#numbers` (Number tab,
 * Stories N1/N2) and `#numbers/products` (Products tab, Stories N3-N5),
 * switched by `TabStrip` inside `NumbersPanel` — no nav-model change needed
 * to add the second tab.
 */

export interface NavItem {
  /** Stable id, used as the i18n key suffix (nav.<id>) and test selector. */
  id: 'health' | 'leads' | 'conversations' | 'config' | 'numbers' | 'products';
  /** Link target when it differs from `#<id>` (Products lives under `#numbers/products`). */
  href?: string;
  /** Live (navigable) vs. a disabled roadmap stub. */
  enabled: boolean;
}

export const NAV_ITEMS: readonly NavItem[] = [
  { id: 'health', enabled: true },
  { id: 'leads', enabled: true },
  { id: 'conversations', enabled: true },
  { id: 'config', enabled: true },
  { id: 'numbers', enabled: true },
  { id: 'products', enabled: true, href: '#numbers/products' },
];
